import { Link } from "react-router-dom";
// import axios from "axios";
// import { useState,useEffect } from "react";
import { useFooterLayouts } from "../../../hooks/apis/main";

function Footer_content() {
  const { data, isLoading, error } = useFooterLayouts();

  if (isLoading) return <div className="active loading">
    <img src="/images/loading.svg" className="img-fluid" alt="loading"/>
  </div>;
  if (error) return <p>Error</p>;
  // const[enamad,setEnamad] = useState('');

  // useEffect(() => {
  //     axios.get('https://panel.baghban.restaurant/api/layouts')
  //         .then(response => {
  //             setEnamad(response.data.enamad_link);
  //             // setslideText(response.data.spotlites[0].text);
  //             console.log(response.data);
  //         })
  //         .catch(error => {
  //             console.error(error);
  //         });
  // }, []);
  return (
    <div className="footer-content">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-12">
            <div className="ft-widget">
              <img
                src={process.env.PUBLIC_URL + "/images/logo-footer.png"}
                className="img-fluid"
                alt=""
                title=""
              />
              <div className="desc">
                {data.footer_text}
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-12 offset-lg-1">
            <div className="ft-widget">
              <h2 className="widget-title">اطلاعات تماس</h2>
              <div className="widget-content">
                {data.contact_infos.map((item,index) => {
                  return (
                    <p className="item" key={index}>
                      {(item.type == 'email') ? <><i className="fas fa-envelope"></i><a href={`mailto:${item.value.replace(/_/g, "")}`}>{item.value.replace(/_/g, "")}</a></> :''}
                      {(item.type == 'phone') ? <><i className="fas fa-phone"></i><a href={`tel:${item.value.replace(/_/g, "")}`}>{item.value.replace(/_/g, "")}</a></> :''}
                      {(item.type == 'address') ? <><i className="fas fa-map-marker-alt"></i><span>{item.value.replace(/_/g, "")}</span></> :''}
                    </p>
                  )

                })}
              </div>
            </div>
          </div>
          <div className="col-lg-3 col-12">
            <div className="ft-widget">
              <h2 className="widget-title">دسترسی سریع</h2>
              <div className="widget-content">
                <ul className="menu">
                  <li>
                    <Link to="menu">منو رستوران</Link>
                  </li>
                  <li>
                    <Link to="menu">منو کافی شاپ</Link>
                  </li>
                  <li>
                    <Link to="about-us">معرفی رستوران</Link>
                  </li>
                  <li>
                    <Link to="contact-us">تماس با ما</Link>
                  </li>
                  <li>
                    <Link to="terms-conditions">قوانین و مقررات</Link>
                  </li>
                  <li>
                    <Link to="privacy">حریم خصوصی</Link>
                  </li>
                  <li>
                    <Link to="faq">سوالات متداول</Link>
                  </li>
                </ul>
              </div>
              <div dangerouslySetInnerHTML={{ __html: data.enamad_link }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer_content;
